import { costByCategoryChartDataCombiner } from "./costByCategoryChartDataCombiner";
import { costByCategoryWidgetDataFilteredByCategoryIdsSelector } from "../data/costByCategoryWidgetDataFilteredByCategoryIdsSelector";
import { RootState } from "../../../../../store";

export const costByCategorySetupChartDataSelector = (
  state: RootState,
  widgetId: string,
  addFilteredResources?: boolean,
) => {
  const data = costByCategoryWidgetDataFilteredByCategoryIdsSelector(
    state,
    widgetId,
    "setup",
  );

  if (!data) {
    return;
  }

  const groupedByDate = costByCategoryChartDataCombiner(
    data,
    !!addFilteredResources,
  );

  return Object.values(groupedByDate);
};
